import { i18n } from '@/i18n';
import { useCouponStore } from '@/store/coupon';
import { useStampStore } from '@/store/stamp';
import { useTaskStore } from '@/store/task';
import { to } from '@/utils/to';
import { CustomException, elk } from '@tencent/ppd-base-libs';
import { hideLoading, IconType, showLoading, showToast } from '@tencent/wphk-act-base-ui';
import { showBusinessError, hideDialog } from '@tencent/wphk-components-dialog';
import { useGuideDriver } from './use-guide-driver';

export function useGlobalData() {
  const taskStore = useTaskStore();
  const stampStore = useStampStore();
  const couponStore = useCouponStore();

  const { showConfig: guideDriverConfig, startGuide, setIsNeedShow } = useGuideDriver();

  // 刷新系统数据
  const refresh = async () => {
    // 印花模块拉取数据(券依赖印花数据)
    await stampStore.qryUserQual();
    await Promise.all([
      // 拉取任务数据
      taskStore.initTaskInfo(),
      // 印花模块拉取数据
      // stampStore.qryUserQual(),
      // 券模块拉取数据
      couponStore.initCouponInfo(),
    ]);
  };

  /** 主動執行的任務-全流程 */
  const autoExecTask = async () => {
    // 執行簽到動作
    const autoExecTask = taskStore.autoExecTaskInfo;
    if (!autoExecTask) {
      // 如果主动执行的任务为空，则退出
      return;
    }
    /** 准备要弹出新手指引弹窗 */
    setIsNeedShow();
    /** 执行签到 */
    showLoading();
    const [err, result] = await to(taskStore.execAutoTask());
    hideLoading();
    /** 处理签到失败逻辑 */
    if (err) {
      console.log('簽到失敗');
      showToast({
        title: i18n('簽到失敗'),
        duration: 2500,
        icon: IconType.fail,
      });
      // 这里不需要把错误往外抛
      new CustomException(err, 'eStampAutoExecFail', '簽到失敗');
      return;
    }
    /** 处理签到成功逻辑 */
    if (result) {
      console.log('簽到成功', result);
      /** 如果需要弹出新手指引弹窗，则启动guide */
      if (guideDriverConfig.isNeedShow) {
        await startGuide();
      }
      /** 指引结束后刷新页面数据 */
      showLoading();
      const [err] = await to(refresh());
      hideLoading();
      if (err) {
        handleRefreshError(err);
        return;
      }
    }
  };

  const handleRefreshError = (e, options?: {isNeedReloadPage: boolean}) => {
    // FIXME: 尽量避免system busy,需要做业务转义
    let dialogConfig = {};
    if (options?.isNeedReloadPage) {
      dialogConfig = {
        btns: [
          {
            text: i18n('刷新'),
            click: () => {
              hideDialog();
              window.location.reload();
            },
          },
        ],
      };
    }
    showBusinessError(e, dialogConfig);
    try {
      elk({
        key: 'showErrorDialog',
        str2: 'refreshError',
        str3: e?.retmsg || e?.message || '網絡異常，請稍後重試',
        msg: JSON.stringify(e),
      });
    } catch (e) { }
  };

  return {
    /** 刷新系统数据 */
    refresh,
    /** 主動執行任務 */
    autoExecTask,
    /** 處理refresh的error */
    handleRefreshError,
  };
}
